module.exports = __webpack_public_path__ + "img/teamine.f591b691.png";